// THE WORKSPACE'S ADDRESS, CLIENT SIDE (launch-marketing-pages M1). `/` is Home;
// the workspace lives here. No imports, so every reader can take it without a
// cycle, `services/sessionToken.js` (which imports nothing from the app) among
// them. Its server twin is `Routes::WORKSPACE_PATH`; `public/sw.js` and the
// manifest's `start_url` write the same path literally.

/** The path of the workspace record (`MainView`, child `MainMap`). */
export const WORKSPACE_PATH = "/base";
